import React, { useCallback, useContext, useEffect, useState } from "react";
import logo from "../../assets/images/simpleStudyingLogo.png";
import Logos from "../../assets/images/fullUpdated.png";
import search_icon from "../../assets/images/search.webp";
import { Link, useHistory, withRouter } from "react-router-dom";
import "./index.css";
import { removeKey, setKey } from "../../helpers";
import { Modal } from "react-responsive-modal";
import Container from "../container";
import Button from "../EmptyButton";
import { useDispatch, useSelector } from "react-redux";
import {
  closeAlert,
  createErrorAlert,
  getSiteSearch,
  initialError,
} from "../../redux/actions";
import ErrorHandler from "../../components/Modal/ErrorHandler";
import Select from "../Select";
import { getApiKey, slugToText } from "../../helpers";
import { debounce } from "lodash";
import ReactGA from "react-ga";
import AppConfig from "../../config/index";
import FullStory from "react-fullstory";
import apiRequest from "../../helpers/apiRequest";
import login from "../../services/Account/login";
import { BsBars } from "react-icons/bs";
import Burger from "../../assets/icons/burger.svg";
import noApiRequests from "../../helpers/noApiRequests";
import LoginModal from "../Modal/LoginModal";
import SignUpModal from "../Modal/SignUpModal";
import Context from "../../services/Context.js";
ReactGA.initialize(AppConfig.GOOGLE.GA_TRACKING_CODE);
const ORG_ID = "S1P4H";

const Logo = ({ showSearch, handleClick, source }) => {
  const history = useHistory();
  return !showSearch ? (
    // <div onClick={() => history.push("/")}>
      <img
        src={source}
        alt="Logo"
        className="h-full w-64 ml-20 lg:mb-0 xl:mb-0 2xl:mb-0"
        onClick={handleClick}
        style={{ cursor: "pointer" }}
      />
    // </div>
  ) : null;
};

const Icon = ({ onClick }) => (
  <img
    src={search_icon}
    className="mr-5 img-fluid"
    alt="search_icon"
    width="23"
    onClick={onClick}
  />
);

const LoginButton = ({ signup, loginModals, setLoginModal, redirectAfterLogin, setLoginRedirectTo }) => {
  const history = useHistory();
  // const [loginModal, setLoginModal] = useState(false);

  const errorAlert = useSelector(({ store }) => store.errorAlertReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    if (loginModals === true) {
      setLoginModal(true);
    }
  }, [loginModals]);

  const loginRoute = (location) => {
    if (location.pathname === "/") {
      history.push("/login");
    } else {
      setLoginRedirectTo?.(null);
      setLoginModal(true);
    }
  };

  const handleClose = () => {
    setLoginModal(false);
    setLoginRedirectTo?.(null);
  };

  return (
    <div className="inline-block mr-2 xl:w-36 text-center py-1 lg:py-2">
      <p
        onClick={() => {
          loginRoute(window.location);
        }}
        className="btn flex-auto border-2  text-13 sm:text-16 border-primary md:border-0 ml-1 text-primary py-1 lg:py-2 px-2 font-bold xl:w-full cursor-pointer"
      >
        Log in
      </p>
      <div className="parent-modal-class">
        <LoginModal
          role="dialog"
          open={loginModals}
          setLoginModal={setLoginModal}
          onClose={handleClose}
          focusTrapped={true}
          blockScroll={true}
          signup={signup}
          redirectAfterLogin={redirectAfterLogin}
          closeOnOverlayClick={false}
          labelledBy="custom-modal-title"
          describedBy="custom-modal-desc"
          center={true}
          style={{zIndex: '2147483649'}}
          classNames={{
            overlay: "custom-overlay-class z-[21474836493742]",
            modal: "react-modal-class1 z-[2147483649473829]",
          }}
        ></LoginModal>
      </div>
    </div>
  );
};

const Search = ({ showSearch, toggleSearch }) => {
  return showSearch ? (
    <div className="flex w-48 sm:w-64  border border-primary-2 pl-4 py-2 rounded-2xl">
      <input
        type="search"
        placeholder="Search Cases"
        className="w-4/5 bg-transparent"
      />
      <Icon onClick={toggleSearch} />
    </div>
  ) : (
    <Icon onClick={toggleSearch} />
  );
};

function Header() {
  const [showSearch, setShowSearch] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const errorAlert = useSelector(({ store }) => store.errorAlertReducer);
  const siteSearchData = useSelector(
    ({ store }) => store.siteSearchReducer.data
  );
  const [confirmModal, setConfirmModal] = useState(false);
  const [signupModal, setSignupModal] = useState(false);
  const [studyModuleRes, setStudyModuleRes] = useState([]);
  const loading = useSelector(({ store }) => store.siteSearchReducer.loading);
  const [module, setModule] = useState([]);
  const [loginModal, setLoginModal] = useState(false);
  const [loginRedirectTo, setLoginRedirectTo] = useState(null);
  const { value: contextValue, updateValue } = useContext(Context);
  const [searchChange, setSearchChange] = useState("Type to Search");

  const toggleSearch = useCallback(
    (event) => {
      event.preventDefault();
      setShowSearch(!showSearch);
    },
    [showSearch]
  );

  useEffect(() => {
    if (contextValue?.requestLoginModal) {
      setLoginModal(true);
      setLoginRedirectTo(contextValue?.loginRedirectTo || null);
      updateValue({ ...contextValue, requestLoginModal: false, loginRedirectTo: null });
    }
  }, [contextValue?.requestLoginModal]);

  const confirmAppoint = async (status) => {
    let url_appoint = window.location.href.split("appointment=");
    let obj;
    if (status !== "") {
      obj = {
        status: status,
        appointment_id: parseInt(url_appoint[1]),
      };
    }

    await apiRequest({
      method: "post",
      url: "content/confirm/appointment/",
      data: obj,
    }).then((res) => {
      if (res?.data?.data.includes("Confirmed")) {
        setTimeout(() => {
          dispatch(
            createErrorAlert(
              201,
              "Success",
              "Congratulations! Your Free Appointment has been confirmed",
              201
            )
          );
        }, 2000);
        setConfirmModal(false);
        history.push("/");
      } else {
        setTimeout(() => {
          dispatch(
            createErrorAlert(
              201,
              "Success",
              "Your Free Appointment has been cancelled",
              201
            )
          );
        }, 2000);
        setConfirmModal(false);
        history.push("/");
      }
    });
  };

  const studyModuleData = async () => {
    await apiRequest({
      method: "get",
      url: "studies/all/studymodules",
    }).then((res) => {
      setStudyModuleRes(res?.data);
    });
  };

  useEffect(() => {
    if (!noApiRequests().includes(window.location.pathname)) {
      studyModuleData();
    }
    dispatch(initialError());
    ReactGA.pageview(window.location.pathname + window.location.search);
    if (window.location.href.includes("free_tutor")) {
      setConfirmModal(true);
    }
  }, []);

  useEffect(() => {
    if (errorAlert?.showAlert) {
      document.body.style.overflowY = "hidden";
      document.body.style.position = "fixed";
    } else if (!errorAlert?.showAlert) {
      document.body.style.overflowY = "unset";
      document.body.style.position = "unset";
    }
    if (siteSearchData) {
      if (siteSearchData.length > 0) {
        let modules = [];
        siteSearchData.map((item) => {
          if (item?.title?.includes("summary")) {
            return null;
          } else {
            modules.push({
              value: item,
              label: `${slugToText(item.title)}  -  ${item.type}`,
            });
          }
        });
        setModule(modules);
      }
    }
  }, [errorAlert, siteSearchData]);

  const handleSelectChange = (change) => {
    if (change.length === 0) {
      setSearchChange("Type to Search");
      return; // Early return if no input
    }

    setSearchChange(
      "We cannot find what you are looking for. You can search by case names or legal principles e.g., consideration"
    );

    debouncedSearch(change);
  };

  const debouncedSearch = useCallback(
    debounce((change) => {
      dispatch(getSiteSearch(change));
    }, 300),
    []
  );

  const handleSelectedModule = (selected) => {
    // if (studyModuleRes.length > 0) {
    // for (let i = 0; i < studyModuleRes.length; i++) {
    if (selected.value.type === "Note") {
      // if (
      //   parseInt(selected?.value?.study_module.id) ===
      //   parseInt(studyModuleRes[i].id) ||
      //   parseInt(selected?.value?.id) === parseInt(studyModuleRes[i].id)
      // ) {
      localStorage.setItem("studyModule", selected?.value?.study_module?.slug);
      if (selected.value.type === "Note") {
        history.push({
          pathname: `/${selected?.value?.study_module?.slug}/notes/${selected.value.slug}`,
          state: { selected },
        });
        window.location.replace(
          `/${selected?.value?.study_module?.slug}/notes/${selected.value.slug}`
        );
      }
      // }
    } else {
      localStorage.setItem("studyModule", selected?.value?.study_module?.slug);
      // if (
      //   parseInt(selected?.value?.study_module) ===
      //   parseInt(studyModuleRes[i].id) ||
      //   parseInt(selected?.value?.id) === parseInt(studyModuleRes[i].id) || parseInt(selected?.value?.study_module?.id) === parseInt(studyModuleRes[i].id)
      // ) {
      if (selected.value.type === "StudyModule") {
        window.location.replace(`/study-module/${selected.value.slug}`)
        // history.push({
        //   pathname: `/study-module/${selected.value.slug}`,
        //   state: { selected },
        // });
      } else if (selected.value.type === "Essay") {
        dispatch(
          createErrorAlert(
            211,
            "Info",
            "To view Model Essays please Login. No SimpleStudy account? Sign Up",
            211
          )
        );
      } else if (selected.value.type === "CaseStudy") {
        history.push({
          pathname: `/${selected.value.slug}/`,
          state: { selected },
        });
        window.location.replace(`/${selected.value.slug}/`);
      } else if (selected.value.type === "TutorialVideo") {
        // window.location.href = selected.value.url;
        dispatch(
          createErrorAlert(
            211,
            "Info",
            "To view Tutorial Videos please Login. No SimpleStudy account? Sign Up",
            211
          )
        );
      } else if (selected.value.type === "Quiz") {
        dispatch(createErrorAlert(211, "", "To view Quiz please Login", 211));
        // history.push({
        //   pathname: `/quiz/${selected.value.slug}/`,
        //   state: {
        //     state: selected.value.slug,
        //     value: studyModuleRes[i].slug,
        //   },
        // });
      } else if (selected.value.type === "FlashCard") {
        dispatch(
          createErrorAlert(
            200,
            "Info",
            `To view Flash Cards you must be logged in. No SimpleStudy account?`,
            200
          )
        );
        // history.push({ pathname: `/${studyModuleRes[i].slug}/flashcards` });
      } else if (selected.value.type === "Blog") {
        history.push({
          pathname: `/blogs/${selected.value.slug}/`,
          state: { selected },
        });
        window.location.replace(`/blogs/${selected.value.slug}/`);
      }
    }
    // }
    //   }
    // }
  };

  const logoClick = () => {
    if (getApiKey()) {
      history.push(`/profile`);
    } else {
      history.push(`/`);
    }
  };
  const contactUs = () => {
    setBurgerMenuOpen(false);
    history.push("/contact-us");
  };

  const handleClose = () => {
    setSignupModal(false);
    setLoginModal(false);
    setLoginRedirectTo(null);
  };

  const signupRoute = (location) => {
    if (location.pathname === "/") {
      history.push("/signup");
    } else {
      setLoginRedirectTo(null);
      setSignupModal(true);
    }
  };
  const tutoring = () => {
    setBurgerMenuOpen(false);
    history.push("/boost-your-grades");
  };

  const [burgerMenuOpen, setBurgerMenuOpen] = useState(false);
  const toggleBurgerMenu = () => {
    setBurgerMenuOpen(!burgerMenuOpen);
  };
  const BurgerMenu = ({ isOpen, toggleMenu }) => {
    return (
      <div className="relative flex justify-center items-center w-fit text-center mx-3 mt-3 custom-sm:mt-0">
        {/* <Button
                text="Here"
                onClick={toggleMenu}    
                className="burger-icon"
                filled
              /> */}
        {/* <div className="relative w-max">
          <img
            src={Burger}
            alt="Burger"
            onClick={toggleMenu}
            style={{ cursor: "pointer" }}
          />
        </div> */}
        {/* <ul className={`burger-menu ${isOpen ? "open" : ""}`}>
          <li className=" cursor-pointer mt-4" onClick={toggleMenu}>
            <div className="z-50 absolute -right-4 top-2 px-8 cursor-pointer mt-6">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 closeIcon"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>
          </li>
          <li className="mt-8">
            <p
              className=" custom:text-14  font-bold mt-12 text-left"
              onClick={contactUs}
              id="menu"
            >
              Contact us
            </p>
          </li>
          <li className="mt-4">
            <p
              className=" custom:text-14  font-bold text-left"
              onClick={tutoring}
              id="menu"
            >
              Tutoring
            </p>
          </li>
        </ul> */}
      </div>
    );
  };
  return (
    <div
      className={`${
        (history.location.pathname === "/study-module/:slug" ||
          history.location.pathname === "/signup" ||
          history.location.pathname === "/login" ||
          history.location.pathname === "/signup/step-one" ||
          history.location.pathname === "/signup/step-two" ||
          history.location.pathname === "/forget-password" ||
          history.location.pathname.includes("auth/reset-password/") ||
          history.location.pathname.includes("aitutor") ||
          history.location.pathname === "/signup/step-three") &&
        "hidden"
      }`}
    >
      <FullStory org={ORG_ID} />
      <ErrorHandler
        isOpen={errorAlert?.showAlert}
        closeModal={(e) => dispatch(closeAlert(e))}
        simpleClose={() => dispatch(initialError())}
        title={errorAlert?.title}
        status={errorAlert?.status}
        content={errorAlert?.message}
      />
      <div className="BoostPWrapper bg-white lg:mt-24 px-4
            md:px-8
            lg:px-36
            xl: px - 60n">
        {/* SMALL HEADER */}
        <div className="smallHeader items-center justify-between pt-4 pb-7 lg:hidden custom-sm:jutify-between">
          <BurgerMenu isOpen={burgerMenuOpen} toggleMenu={toggleBurgerMenu} />

          <Logo
            showSearch={showSearch}
            handleClick={logoClick}
            source={Logos}
          />
          <div className="flex items-center sHBtnSec xs:hidden sm:block lg:flex">
            {/* <Select
              placeholder="Search Cases, Topics, Legal Principles, Study Modules etc"
              values={module}
              handleSelected={handleSelectedModule}
              valueChange={handleSelectChange}
              noOptionMessage={searchChange}
              loading={loading}
            /> */}
            <div className="searchWrap  searchWrap2 searchWrapTwo md:w-80 sm:w-64 custom-sm:ml-28 block lg:hidden">
              <Select
                placeholder={"Search"}
                values={module}
                id="topSearch"
                handleSelected={handleSelectedModule}
                valueChange={handleSelectChange}
                noOptionMessage={
                  <div className="relative" style={{ overflow: "hidden" }}>
                    {searchChange}
                    <div
                      className="bg-primary text-white text-center py-2 h-auto w-full mt-2 z-20 cursor-pointer"
                      onClick={() => {
                        setLoginRedirectTo("/aitutor");
                        setLoginModal(true);
                      }}
                    >
                      <p>ASK THE AI TUTOR INSTEAD</p>
                    </div>
                  </div>
                }
                loading={loading}
              />
              <div className="searchIcon">
                <img src={search_icon} alt="search_icon" width="23" />
              </div>
            </div>
            <div className="signUISec">
              <LoginButton signup={setSignupModal} loginModals={loginModal} setLoginModal={setLoginModal} redirectAfterLogin={loginRedirectTo} setLoginRedirectTo={setLoginRedirectTo}/>
              <div className="homeSignUpBtn block lg:hidden custom2:w-40">
                <Button
                  text="Sign Up"
                  onClick={() => signupRoute(window.location)}
                  filled
                />
              </div>
            </div>
          </div>
        </div>

        {/* BIGGER HEADER */}
        <div
          className="hidden lg:flex fixed top-0 left-16 w-full justify-between items-center py-8 px-8 bg-white shadow-sm"
          style={{
            zIndex: (loginModal || signupModal) === true ? 0 : 2147483647, // max safe z-index
            position: "fixed",
            width: "97%",
            backgroundColor: "#fffaf4",
          }}
        >
          {" "}
          <div
            onClick={() => {
              history.push("/");
            }}
          >
            <div
              className="custom:hidden"
              onClick={() => {
                history.push("/");
              }}
            >
              {/*<Logo/>*/}
            </div>
            <div
              onClick={() => {
                history.push("/");
              }}
            >
              <Logo
                showSearch={showSearch}
                handleClick={logoClick}
                source={Logos}
                asdsad
              />
            </div>
          </div>
          <div className="relative w-96">
              <Select
                placeholder="Search for courses and study materials"
                values={module}
                id="topSearch"
                handleSelected={handleSelectedModule}
                valueChange={handleSelectChange}
                noOptionMessage={
                  <div className="relative overflow-hidden">
                    {searchChange}
                    <div
                      className="bg-primary text-white text-center py-2 mt-2 rounded-xl w-full cursor-pointer"
                      onClick={() => {
                        setLoginRedirectTo("/aitutor");
                        setLoginModal(true);
                      }}
                    >
                      <p>ASK THE AI TUTOR INSTEAD</p>
                    </div>
                  </div>
                }
                loading={loading}
                className="w-full h-12 pl-12 pr-4 border-2 border-[#D58C5A] rounded-full text-gray-600 placeholder-gray-500"
              />

              {/* search icon - no border */}
              <div className="absolute right-8 top-4 bg-white -translate-y-2">
                <img src={search_icon} alt="search_icon" width="18" />
              </div>
            </div>
          <div className="flex items-center">
            <LoginButton signup={setSignupModal} loginModals={loginModal} setLoginModal={setLoginModal} redirectAfterLogin={loginRedirectTo} setLoginRedirectTo={setLoginRedirectTo} />
            <div className="hidden md:block custom2:w-40">
              <Button
                text="Sign Up"
                onClick={() => signupRoute(window.location)}
                filled
              />
            </div>
          </div>
          {/* <div className="nav-item px-2.5 pr-0 hidden 1200:block">
            <p
              className="btn flex-auto border-2 border-primary md:border-0 ml-1 text-black py-2 px-2 font-bold xl:w-full"
              style={{ cursor: "pointer" }}
              onClick={contactUs}
            >
              Contact Us
            </p>
          </div> */}
          {/* <div className="nav-item px-2.5 pr-0 hidden 1200:block">
            <p
              className="btn flex-auto border-2 border-primary md:border-0 ml-1 text-primary py-2 px-2 font-bold xl:w-full"
              style={{ cursor: "pointer" }}
              onClick={tutoring}
            >
              Tutoring
            </p>
          </div> */}
        </div>
        <SignUpModal
          role="dialog"
          open={signupModal}
          onClose={handleClose}
          setSignupModal={setSignupModal}
          login={setLoginModal}
          redirectAfterLogin={loginRedirectTo}
          focusTrapped={true}
          center
          classNames={{
            overlay: "custom-overlay-class z-[999999999999999999]",
            modal: "react-modal-class1 z-[99999999999999999]",
          }}
        />
        <Modal role="dialog" open={confirmModal} focusTrapped={true} center>
          <div>
            <p className="text-darkest md:text-h3 font-bold mb-5">
              Please CONFIRM OR CANCEL your tutoring session at StudyCrowd.AI
            </p>
            <div className="flex flex-col justify-center items-center md:justify-between md:flex-row md:space-x-5 w-full mt-4 md:mt-10">
              <div className="w-56">
                <Button
                  simple
                  onClick={() => {
                    confirmAppoint("CANCEL");
                  }}
                >
                  <p className="text-center text-14 xl:text-body-large">
                    Cancel
                  </p>
                </Button>
              </div>
              <div className="w-56 mt-5 md:mt-0">
                <Button
                  filled
                  onClick={() => {
                    confirmAppoint("CONFIRM");
                  }}
                >
                  <p className="text-center text-14 xl:text-body-large">
                    Confirm
                  </p>
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
}

export default withRouter(Header);
